import React from "react";
import { useParams } from "react-router-dom";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import Header from "../../components/Header";
import Menu from "../../components/Menu";
import FormUsuarios from "../../components/FormUsuarios";

const PageUsuariosForm = () => {
  let params = useParams("id");

  return (
    <React.Fragment>
      <Header />
      <Container maxWidth="lg" sx={{ mt: 2 }}>
        <Grid container spacing={4}>
          <Grid item xs={3}>
            <Menu active="usuarios" />
          </Grid>
          <Grid item xs={9} sx={{ mt: 1 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {params.id ? "Editar" : "Adicionar"} Usuario
            </Typography>
            <Box sx={{ pr: 5 }}>
              <FormUsuarios id={params.id} listURL="/usuarios" />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default PageUsuariosForm;
